import React, { useEffect, useState } from "react";
import FilterListIcon from "@mui/icons-material/FilterList";
import { MdOutlineErrorOutline } from "react-icons/md";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import DropOutModal from "../../../components/ModalComponents/DropOutModal";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useAppDispatch } from "../../../useStore";
import { reset } from "../../../features/Applicant/applicantSlice";
import toast, { Toaster } from "react-hot-toast";
import { EntriesPerPage, Search, TableFetch } from "../../../components/TableOptions";
import Pagination from "../../../components/Pagination";
import moment from "moment";
import XLoader from "../../../components/XLoader";
import { FaFilePdf, FaFileCsv, FaFileImage, FaFile } from "react-icons/fa";
import PdfViewer from "../../../components/PdfViewer";
import ImageLightbox from "../../../components/ImageLightbox";
import TranningModal from "../../Tranning/TranningModal";
import EditApplicant from "../../../components/ModalComponents/EditApplicant";
import HireModal from "../../../components/ModalComponents/HireModal";
import UpdateTraningModal from "../../../components/ModalComponents/UpdateTraningModal";
import _ from "lodash";
import ReplaceID from "../../../components/ModalComponents/ReplaceID";
import SendHireDrawerComponent from "../ApplicantDrawerComponent/SendHireDrawerComponent";


const TranningTable = ({
  pageHeader,
  headerTitles,
  data,
  isLoading,
  message,
  isError,
  setResetID

}: any) => {
  const dispatch = useAppDispatch();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState<string[]>([]); // State to hold selected IDs
  const [selectedItems, setSelectedItems] = useState<any[]>([]); // State to hold selected items
  const handleCheckboxChange = (itemId: string, item: any) => {
      setIsDrawerOpen(true);
      // Check if the item's ID is already selected
      if (selectedIds.includes(itemId)) {
        // Remove the ID from the selectedIds array
        setSelectedIds(selectedIds.filter((id) => id !== itemId));
        setSelectedItems((prevSelectedItems) => prevSelectedItems.filter((i) => i.id !== itemId));
      } else {
        // Add the ID to the selectedIds array
        setSelectedIds([...selectedIds, itemId]);
        setSelectedItems((prevSelectedItems) => [...prevSelectedItems, item]);
      }
    };
  const [hasErrorBeenShown, setHasErrorBeenShown] = useState(false);
  useEffect(() => {
    if (isError) {
      toast.error(message);
    }
    dispatch(reset());
  }, [dispatch, isError, message]);
  const [datas, setDatas] = useState([]);
  const [searchItem, setSearchItem] = useState("");

  const [entriesperpage, setEntriesPerPage] = useState(() => {
    return "8";
  });

  const [show, setShow] = useState(false);
  const [isPDF, setIsPDF] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const openModal = (fileUrl, fileType, file) => {
    setSelectedFile(file);
    setIsPDF(fileType === 'pdf');
    setShow(true);
  };


  const getFileIcon = (fileType: any) => {
    switch (fileType) {
      case 'pdf':
        return <FaFilePdf color={"red"} size={25} />;
      case 'csv':
        return <FaFileCsv size={25} color={"green"} />;
      case 'jpeg':
      case 'jpg':
      case 'png':
        return <FaFileImage size={25} color={"gray"} />;
      default:
        return <FaFile size={25} />;
    }
  };

  useEffect(() => {
    const result = data?.data?.filter((item: any) =>
      item?.firstName?.toLowerCase()?.includes(searchItem) ||
      item?.middleName?.toLowerCase()?.includes(searchItem) ||
      item?.LastName?.toLowerCase()?.includes(searchItem)
    );
    setDatas(result);
  }, [data, searchItem]);

  const [displayData, setDisplayData] = useState([]);

  const handleShow = _.debounce(() => {
    if (!hasErrorBeenShown) {
      toast.error("Training has not been completed!");
      setHasErrorBeenShown(true);
    }
    setTimeout(() => {
      setHasErrorBeenShown(false);
    }, 5000);
  }, 300);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
   }; 
  
  return (
    <div>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 5000,
          error: {
            duration: 20000,
          },
        }}
      />
      <section className="md-ui component-data-table">
        <header className="main-table-header">
          <div className="main-table-search-container">
            <h1 className="table-header--title">{pageHeader}</h1>
            <Search searchItem={searchItem} setSearchItem={setSearchItem} placeholder={pageHeader} />
            <div>
              <EntriesPerPage
                data={datas}
                entriesperpage={entriesperpage}
                setEntriesPerPage={setEntriesPerPage}
              />
            </div>
            <span className="table-header--icons">
              <FilterListIcon />
            </span>
          </div>
        </header>
        {isLoading && <XLoader isLoading={isLoading} />}
        <div className="main-table-wrapper">
          <table className="main-table-content">
            <thead className="data-table-header">
              <tr className="data-table-row">
                {headerTitles.map((title: any, i: any) => (
                  <td
                    className="table-datacell datatype-string headerTitles"
                    key={i}
                  >
                    {title}
                  </td>
                ))}
              </tr>
            </thead>
            <tbody className="data-table-content">
              {isLoading ? (
                <TableFetch colSpan={12} />
              ) : displayData?.length === 0 ||
                displayData?.length === undefined ? (
                <tr>
                  <td className="table-msg" colSpan={12}>
                    <MdOutlineErrorOutline size={75} />
                    <p>No Record found!</p>
                  </td>
                </tr>
              ) : (
                displayData?.map((item: any, i: any) => (
                  <tr className="data-table-row" key={i}>
                          <td>
    {item?.Training?.trainingStatus === "PENDING" ? (
      <div className="md-checkbox">
        <input
          id={`pending-${i}`}
          type="checkbox"
          onClick={handleShow}
        />
        <label htmlFor={`pending-${i}`}></label>
      </div>
    ) : (
      <div className="md-checkbox">
        <input
          id={`completed-${i}`}
          type="checkbox"
          checked={selectedIds?.includes(item?.id) || false} // Ensuring a boolean value
          onChange={() => handleCheckboxChange(item?.id, item)}
        />
        <label htmlFor={`completed-${i}`}></label>
      </div>
    )}
  </td>
                    <td className="table-datacell datatype-string">
                      <div className="dropdown">
                        <button className="dropbtn">
                          < MoreHorizIcon />
                        </button>
                        <div className="dropdown-content">
                          <a>

                            {item?.Training?.trainingStatus !== "COMPLETED" ? (
                              <div onClick={handleShow}>Hire</div>
                            ) : (
                              <HireModal
                                title="Hire"
                                // id={item?.id}
                                id={[item?.id]}
                                name={`${!item?.firstName ? "" : item?.firstName} ${!item?.middleName ? "" : item.middleName} ${!item?.LastName ? "" : item?.LastName}`.trim()}
                                recruiterID={item?.recruiterID}
                              />
                            )}
                          </a>
                          <a>
                            <DropOutModal
                              title="Dropout"
                              id={item?.id}
                              name={`${!item.firstName ? "" : item.firstName} ${!item.middleName ? "" : item.middleName} ${!item.LastName ? "" : item.LastName}`.trim()}
                            />
                          </a>
                        </div>
                      </div>
                    </td>
                    <td className="table-datacell datatype-string">
                      <UpdateTraningModal
                        disabled={item?.Training?.trainingStatus === "COMPLETED"}
                        id={item?.Training?.id}
                        name={`${!item?.firstName ? "" : item?.firstName} ${!item?.middleName ? "" : item.middleName} ${!item?.LastName ? "" : item?.LastName}`.trim()} />
                    </td>
                    <td className="table-datacell datatype-numeric toggle">
                      {!item.firstName ? "" : item.firstName} {!item.middleName ? "" : item.middleName} {!item.LastName ? "" : item.LastName}
                    </td>
                    <td className="table-datacell datatype-string">
                      {item?.gender}
                    </td>
                    <td className="table-datacell datatype-string">
                      {moment(!item?.dateOfBirth ? "n/a" : item?.dateOfBirth).format("DD-MM-YYYY")}
                    </td>
                    <td className="table-datacell datatype-string">
                      <Link
                        to={`/viewapplicants/${item?.id}`}
                        className="applicant-btn" >
                        <Button className="view-job-profile">View</Button>
                      </Link>
                    </td>
                    <td className="table-datacell datatype-string">
                      {item?.verificationID
                        ? (
                          <div className="table-datacell-flex">
                          <span
                            style={{ marginRight: '5px', cursor: 'pointer' }}
                            onClick={() => {
                              const fileExtension = item?.verificationID.split('.').pop().toLowerCase();
                              openModal(item?.verificationID, fileExtension, item?.verificationID,);
                            }}>
                            {getFileIcon(item?.verificationID.split('.').pop().toLowerCase())}
                          </span>
                          <ReplaceID id={item?.id} setResetID={setResetID} />
                         </div>
                        )
                        : <div className="table-datacell-flex">
                            <span>
                              No ID
                            </span>
                            <ReplaceID id={item?.id} setResetID={setResetID} />
                          </div>
                      }
                    </td>
                    <td className="table-datacell datatype-string">
                      {moment(item?.createdAt).format("DD-MM-YYYY")}
                    </td>

                    <td className="table-datacell datatype-numeric">
                      <TranningModal data={item} item={item} />
                    </td>
                    <td>{item?.email}</td>

                    <td className="table-datacell datatype-numeric">
                      {!item?.phoneNumber ? "n/a" : item?.phoneNumber}
                    </td>

                    <td className="table-datacell datatype-numeric">
                      {item?.InterviewLog?.interviewScore}
                    </td>
                    <td className="table-datacell datatype-string">
                      {item?.totalWorkExperience}
                    </td>

                    <td className="table-datacell datatype-string">
                      {item?.relevantWorkExperience}
                    </td>
                    <td className="table-datacell datatype-string">
                      {!item?.location ? "n/a" : item?.location}
                    </td>
                    <td className="table-datacell datatype-string">
                      <EditApplicant name={item} id={item?.id} />
                    </td>
                    <td className="table-datacell datatype-string">
                      {moment(item?.Training?.endDate).format("DD-MM-YYYY")}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          {isPDF ? (
            <PdfViewer fileUrl={selectedFile} setShow={setShow} show={show} />
          ) : (
            <ImageLightbox images={selectedFile} setShow={setShow} show={show} />
          )}
        </div>
        <div className="table-footer">
          <div>
            <Pagination
              setDisplayData={setDisplayData}
              data={datas}
              entriesperpage={entriesperpage}
              Total={"Offered"}
            />
          </div>
          <SendHireDrawerComponent 
               isOpen={isDrawerOpen} onClose={toggleDrawer} data={selectedItems} id={selectedIds} />
        </div>
      </section>
    </div>
  );
};

export default TranningTable;
